type SWUpdateCallback = (registration: ServiceWorkerRegistration) => void;

/**
 * Registers the app service worker in production only.
 *
 * - Does NOT cache API/auth requests (handled in public/sw.js)
 * - Uses a conservative update policy (new SW activates when old tabs close)
 */
export function registerServiceWorker(onUpdate?: SWUpdateCallback) {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  const swUrl = `${process.env.PUBLIC_URL || ''}/sw.js`;

  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register(swUrl);

      // If there's already a waiting worker (e.g. installed while the app was backgrounded),
      // surface the update immediately.
      if (registration.waiting && navigator.serviceWorker.controller) {
        onUpdate?.(registration);
      }

      registration.addEventListener('updatefound', () => {
        const installing = registration.installing;
        if (!installing) return;

        installing.addEventListener('statechange', () => {
          // 'installed' fires both on first install and on update
          if (installing.state === 'installed' && navigator.serviceWorker.controller) {
            onUpdate?.(registration);
          }
        });
      });

      // Ensure long-running PWAs periodically check for new deployments.
      const checkForUpdates = () => registration.update().catch(() => {});
      window.addEventListener('focus', checkForUpdates);
      window.addEventListener('online', checkForUpdates);
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') checkForUpdates();
      });
      setInterval(checkForUpdates, 60 * 60 * 1000); // hourly
    } catch (e) {
      // Never block the app if SW registration fails
      // eslint-disable-next-line no-console
      console.warn('Service worker registration failed:', e);
    }
  });
}


